import React from 'react';
import { costRows, costHeading, costPayoff, costSubPayoff } from '../data/tables';
export function CostOfInaction() {
  return <section aria-labelledby="cost-heading" className="bg-paper" data-id="element-78" data-mp="2pz9cw58hapca">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 md:py-28" data-id="element-79" data-mp="2uxasuhaly8jj">
        <h2 id="cost-heading" className="max-w-[36rem] font-serif text-[30px] font-semibold leading-[1.12] tracking-[-0.015em] text-ink md:text-[44px]" data-id="element-80" data-mp="2zwx9z1tk48xm">
          {costHeading}
        </h2>

        {/* Mobile: stacked rows */}
        <ul className="mt-10 space-y-4 md:hidden" data-id="element-81" data-mp="38w25dz9tnm5k">
          {costRows.map(row => <li key={row.problem} className="border border-brass/30 bg-white rounded-sharp" data-id="element-82" data-mp="3dpmvz6935duq">
              <p className="px-5 py-4 text-[15px] leading-[1.5] text-slate" data-id="element-83" data-mp="3imddly0jghi9">{row.problem}</p>
              <p className="border-t border-brass/20 bg-paper px-5 py-3 font-mono text-[12px] uppercase leading-[1.5] tracking-label text-brick" data-id="element-84" data-mp="3nnkjfrj4f6ma">
                {row.cost}
              </p>
            </li>)}
        </ul>

        {/* Desktop: table */}
        <table className="mt-12 hidden w-full border-collapse border border-brass/30 text-left md:table" data-id="element-85" data-mp="39hd52nzk1mm4">
          <thead data-id="element-86" data-mp="34i0h1zwy69hy">
            <tr data-id="element-87" data-mp="34hieymnlt124">
              <th scope="col" className="w-3/5 border-b border-brass/30 bg-white px-5 py-4 font-mono text-[10px] uppercase tracking-label text-slate md:px-6" data-id="element-88" data-mp="34j1u29xix62b">
                What stays unwritten
              </th>
              <th scope="col" className="border-b border-l border-brass/30 bg-white px-5 py-4 font-mono text-[10px] uppercase tracking-label text-brick md:px-6" data-id="element-89" data-mp="3s84o6h9cgrdp">
                The real cost
              </th>
            </tr>
          </thead>
          <tbody data-id="element-90" data-mp="js1gibi8f2pd">
            {costRows.map((row, index) => <tr key={row.problem} className={index % 2 === 0 ? 'bg-paper' : 'bg-white'} data-id="element-91" data-mp="jtcic5s4a0du" data-mpi={index}>
                <td className="border-b border-brass/20 px-5 py-5 text-[15px] leading-[1.55] text-slate md:px-6 md:text-[16px]" data-id="element-92" data-mp="ezruh6k8mmsd">
                  {row.problem}
                </td>
                <td className="border-b border-l border-brass/20 px-5 py-5 font-mono text-[13px] leading-[1.5] text-brick md:px-6 md:text-[14px]" data-id="element-93" data-mp="2e6yfgeh74tm8">
                  {row.cost}
                </td>
              </tr>)}
          </tbody>
        </table>

        <p className="mt-10 max-w-[36rem] font-serif text-[22px] italic leading-[1.4] text-ink md:mt-12 md:text-[30px]" data-id="element-94" data-mp="1qiyqnk3g3daa">
          {costPayoff}
        </p>
        <p className="mt-4 font-mono text-[12px] uppercase tracking-label text-brass" data-id="element-95" data-mp="1vj38pek04g2m">
          {costSubPayoff}
        </p>
      </div>
    </section>;
}